export const demoNodes = [
  {
    id: '1',
    type: 'cohortNode',
    position: { x: 0, y: 0 },
    data: {
      label: 'Root Cohort',
      status: 'executed',
      patientCount: 1000,
      criteria: {
        include: [
          { field: 'Diagnosis', operator: 'contains', value: 'Lung cancer' },
          { field: 'Age', operator: 'gte', value: '18' },
        ],
        exclude: [{ field: 'Prior chemotherapy', operator: 'equals', value: 'Yes' }],
      },
      criteriaCount: { include: 2, exclude: 1 },
      description: 'All lung cancer patients',
    },
  },
  {
    id: '2',
    type: 'cohortNode',
    position: { x: 0, y: 0 },
    data: {
      label: 'Sub-Cohort 1',
      status: 'edited',
      criteria: {
        include: [{ field: 'Tumor stage', operator: 'equals', value: 'Stage IV' }],
        exclude: [],
      },
      criteriaCount: { include: 1, exclude: 0 },
      description: 'Stage IV',
    },
  },
  {
    id: '3',
    type: 'cohortNode',
    position: { x: 0, y: 0 },
    data: {
      label: 'Sub-Cohort 2',
      status: 'executing',
      criteria: {
        include: [
          { field: 'Mutation', operator: 'contains', value: 'EGFR' },
          { field: 'Smoking status', operator: 'equals', value: 'Never smoker' },
        ],
        exclude: [{ field: 'Brain metastases', operator: 'equals', value: 'Yes' }],
      },
      criteriaCount: { include: 2, exclude: 1 },
      description: 'EGFR mutation',
    },
  },
  {
    id: '4',
    type: 'cohortNode',
    position: { x: 0, y: 0 },
    data: {
      label: 'Refinement A',
      status: 'error',
      criteria: {
        include: [{ field: 'Therapy line', operator: 'equals', value: 'First line' }],
        exclude: [
          { field: 'Prior treatment', operator: 'equals', value: 'Any' },
          { field: 'ECOG', operator: 'gte', value: '3' },
        ],
      },
      criteriaCount: { include: 1, exclude: 2 },
      description: 'No prior treatment',
    },
  },
  {
    id: '5',
    type: 'cohortNode',
    position: { x: 0, y: 0 },
    data: {
      label: 'Refinement B',
      status: 'unedited',
      criteria: {
        include: [],
        exclude: [],
      },
      criteriaCount: { include: 0, exclude: 0 },
      description: 'Smokers only',
    },
  },
];

export const demoEdges = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e1-3', source: '1', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4' },
  { id: 'e3-5', source: '3', target: '5' },
];

export const generateDemoTree = (nodeCount = 60) => {
  // Simple generator to quickly test responsiveness/performance with 50+ nodes.
  const nodes = [];
  const edges = [];

  for (let i = 1; i <= nodeCount; i += 1) {
    const status =
      i === 1
        ? 'executed'
        : i % 11 === 0
          ? 'error'
          : i % 7 === 0
            ? 'executing'
            : i % 3 === 0
              ? 'edited'
              : 'unedited';

    nodes.push({
      id: String(i),
      type: 'cohortNode',
      position: { x: 0, y: 0 },
      data: {
        label: i === 1 ? 'Root Cohort' : `Cohort ${i}`,
        status,
        patientCount:
          status === 'executed' ? Math.max(1, Math.floor(1000 / (1 + Math.log(i + 1)))) : undefined,
        criteria:
          status === 'unedited'
            ? { include: [], exclude: [] }
            : {
                include: Array.from({ length: i % 4 }, (_, idx) => ({
                  field: `Include rule ${idx + 1}`,
                  operator: 'equals',
                  value: `value-${idx + 1}`,
                })),
                exclude: Array.from({ length: i % 3 }, (_, idx) => ({
                  field: `Exclude rule ${idx + 1}`,
                  operator: 'equals',
                  value: `value-${idx + 1}`,
                })),
              },
        criteriaCount:
          status === 'unedited' ? { include: 0, exclude: 0 } : { include: i % 4, exclude: i % 3 },
      },
    });
  }

  for (let i = 2; i <= nodeCount; i += 1) {
    const parent = String(Math.max(1, Math.floor(i / 2)));
    edges.push({ id: `e${parent}-${i}`, source: parent, target: String(i) });
  }

  return { nodes, edges };
};
